import {preparationTasks,type ProgramPreparation} from './audition-plan';
export function todayTasks(plan:ProgramPreparation,deadline:string,now=Date.now()) {
 const days=(new Date(deadline).getTime()-now)/86400000;
 const phases=days<=1?['upload']:days<8?['recording','upload']:['application','recording'];
 return preparationTasks.filter(t=>phases.includes(t.phase)&&(plan.taskStates[t.id]??'pending')==='pending').slice(0,3);
}
